import { render, staticRenderFns } from "./TabsForm.vue?vue&type=template&id=52f7c6d6&scoped=true"
import script from "./TabsForm.vue?vue&type=script&lang=js"
export * from "./TabsForm.vue?vue&type=script&lang=js"
import style0 from "./TabsForm.vue?vue&type=style&index=0&id=52f7c6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f7c6d6",
  null
  
)

export default component.exports